var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { A3iService } from 'app/services/a3i.service';
import { ActivityService } from 'app/services/activity.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { EditService } from 'app/services/edit.service';
import { FieldMappingService } from 'app/services/field-mapping.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { GfoService } from 'app/services/gfo.service';
import { LayerQcService } from 'app/services/layer-qc.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { MainDataService } from 'app/services/main-data.service';
import { UserService } from 'app/services/user.service';
import { ToastrService } from 'ngx-toastr';
var A3iWizardComponent = /** @class */ (function () {
    function A3iWizardComponent(toastr, a3iService, activityService, appinfoService, attrIndexService, commonService, editService, fieldMappingService, floatPopupService, gfoService, layerService, mainDataService, mapService, mapLayerService, qcService, userService) {
        this.toastr = toastr;
        this.a3iService = a3iService;
        this.activityService = activityService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.commonService = commonService;
        this.editService = editService;
        this.fieldMappingService = fieldMappingService;
        this.floatPopupService = floatPopupService;
        this.gfoService = gfoService;
        this.layerService = layerService;
        this.mainDataService = mainDataService;
        this.mapService = mapService;
        this.mapLayerService = mapLayerService;
        this.qcService = qcService;
        this.userService = userService;
        this.steps = [
            {
                num: 1,
                label: 'Set parsing direction',
                prop: 'setParsing',
                isFirst: true
            }, {
                num: 2,
                label: 'Extend RCL selection to entire street',
                prop: 'setEntireStreet',
            }, {
                num: 3,
                label: 'Select RCL(s)',
                prop: 'selectRCLs',
                isLast: true
            }
        ];
        this.parsingDirection = 'legacyToNena';
        this.isExtendEntireStreet = true;
        // selectedRoads: any[] = [];
        this.selectedRoadsById = {};
    }
    A3iWizardComponent.prototype.close = function () {
        this.removeAll();
        this.floatPopupService.closePopup(A3iWizardComponent);
    };
    A3iWizardComponent.prototype.cancel = function () {
        this.close();
    };
    A3iWizardComponent.prototype.apply = function () {
        return __awaiter(this, void 0, void 0, function () {
            var prefix, addresses, cols, spinnerId, rsp, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prefix = this.centerlineCate.colPrefix;
                        addresses = [];
                        cols = this.parsingDirection === 'legacyToNena' ? this.lstStandardCols : this.stStandardCols;
                        Object.keys(this.selectedRoadsById).forEach(function (featId) {
                            if (!_this.selectedRoadsById[featId] || !_this.selectedRoadsById[featId].attrs) {
                                _this.toastr.warning('Cannot find attribute for line ' + featId);
                                return;
                            }
                            var attrs = _this.selectedRoadsById[featId].attrs;
                            var inputAddr = _this.a3iService.combinePartsToAddress(cols, prefix, attrs);
                            _this.selectedRoadsById[featId].parseAddress = inputAddr;
                            if (addresses.indexOf(inputAddr) === -1) {
                                addresses.push(inputAddr);
                            }
                        });
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.a3iService.parseAddress(addresses, this.userService.customerInfo.givState)];
                    case 2:
                        rsp = _a.sent();
                        this.handleParseResult(rsp.data);
                        this.selectedRoadsById = {};
                        this.close();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        this.toastr.error('Failed.');
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    A3iWizardComponent.prototype.checkGoNextDisabled = function (stepProp) {
        switch (stepProp) {
            case 'selectRCLs':
                return !Object.keys(this.selectedRoadsById).length;
        }
    };
    A3iWizardComponent.prototype.goPrev = function () {
        if (this.currentStep.isFirst) {
            return;
        }
        var stepNum = this.currentStep.num - 1;
        var step = this.steps.find(function (i) { return i.num === stepNum; });
        this.changeCurrentStep(step);
    };
    A3iWizardComponent.prototype.goNext = function () {
        // Last step: add cards
        if (this.currentStep.isLast) {
            this.apply();
            return;
        }
        var stepNum = this.currentStep.num + 1;
        var step = this.steps.find(function (i) { return i.num === stepNum; });
        // if (this.checkGoNextDisabled(step.prop)) {
        // 	return;
        // }
        this.changeCurrentStep(step);
    };
    A3iWizardComponent.prototype.removeAll = function () {
        this.mapService.endPickOnMap(this.map);
        if (this.map.addedLayers[this.mapLayerService.addressLineLayerName]) {
            this.map.removeLayer(this.mapLayerService.addressLineLayerName);
        }
    };
    A3iWizardComponent.prototype.changeCurrentStep = function (step) {
        if (this.currentStep && this.currentStep.prop === 'selectRCLs') {
            this.mapService.endPickOnMap(this.map);
        }
        switch (step.prop) {
            case 'setParsing':
                break;
            case 'selectRCLs':
                this.startPickLine();
                break;
        }
        this.currentStep = step;
    };
    A3iWizardComponent.prototype.startPickLine = function () {
        var _this = this;
        var layers = [this.mapLayerService.dataLayerName, this.mapLayerService.bgSurroundingsLayerName];
        this.mapService.startPickOnMap(this.map, layers, function (result) { return __awaiter(_this, void 0, void 0, function () {
            var line, lineLayer_1, featId, info, extendMark_1, extendMark_2, grdId, extendedIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        line = result.feat;
                        if (!line) return [3 /*break*/, 6];
                        lineLayer_1 = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
                        featId = line.getId();
                        info = this.selectedRoadsById[featId];
                        if (!info) return [3 /*break*/, 1];
                        extendMark_1 = info.extendMark;
                        delete this.selectedRoadsById[featId];
                        lineLayer_1.getSource().removeFeature(line);
                        // Remove extended lines
                        if (this.isExtendEntireStreet && extendMark_1) {
                            Object.keys(this.selectedRoadsById).forEach(function (id) {
                                var otherLine = _this.selectedRoadsById[id];
                                if (otherLine.extendMark === extendMark_1) {
                                    if (otherLine.feat) {
                                        lineLayer_1.getSource().removeFeature(otherLine.feat);
                                    }
                                    delete _this.selectedRoadsById[id];
                                }
                            });
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, this.updateRoadsInfo([featId])];
                    case 2:
                        _a.sent();
                        info = this.selectedRoadsById[featId];
                        info.feat = line;
                        lineLayer_1.getSource().addFeature(line);
                        if (!this.isExtendEntireStreet) return [3 /*break*/, 5];
                        extendMark_2 = this.commonService.getRandomId();
                        info.extendMark = extendMark_2;
                        grdId = info.attrs[this.attrIndexService.rcIdCol];
                        return [4 /*yield*/, this.a3iService.getRclByRcl(this.centerlineLayerId, grdId)];
                    case 3:
                        extendedIds = _a.sent();
                        return [4 /*yield*/, this.updateRoadsInfo(extendedIds)];
                    case 4:
                        _a.sent();
                        extendedIds.forEach(function (id) {
                            _this.updateStoredFeat(id);
                            _this.selectedRoadsById[id].extendMark = extendMark_2;
                        });
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.toastr.info('Centerline not found.');
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        }); });
        this.mapService.addMapDblclickStop(this.map, function () {
            _this.mapService.endPickOnMap(_this.map);
        });
    };
    A3iWizardComponent.prototype.updateRoadsInfo = function (featIds) {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, idsWithoutAttr, filter, gfo, rsp, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        idsWithoutAttr = featIds.filter(function (id) {
                            if (!_this.selectedRoadsById[id] || !_this.selectedRoadsById[id].attrs) {
                                var attrs = _this.mainDataService.getDataAttrs(id);
                                if (attrs) {
                                    if (!_this.selectedRoadsById[id]) {
                                        _this.selectedRoadsById[id] = {};
                                    }
                                    _this.selectedRoadsById[id].attrs = attrs;
                                    return false;
                                }
                                return true;
                            }
                        });
                        if (!idsWithoutAttr.length) return [3 /*break*/, 3];
                        filter = this.gfoService.getFilter(this.attrIndexService.rcUuidCol, this.appinfoService.filterOperators.in.name, idsWithoutAttr);
                        gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
                        return [4 /*yield*/, this.qcService.getQcFeatureReport(this.centerlineLayerId, null, gfo, {
                                pageNumber: 0
                            })];
                    case 2:
                        rsp = _a.sent();
                        if (rsp.data) {
                            rsp.data.forEach(function (data) {
                                var featId = data[_this.attrIndexService.rcUuidCol];
                                _this.mainDataService.addDataToStoredRecords([data], _this.attrIndexService.rcUuidCol, 'replace');
                                if (!_this.selectedRoadsById[featId]) {
                                    _this.selectedRoadsById[featId] = {};
                                }
                                _this.selectedRoadsById[featId].attrs = data;
                            });
                        }
                        else {
                            this.toastr.warning('Can not find centerline attributes.');
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    A3iWizardComponent.prototype.updateStoredFeat = function (id) {
        var _this = this;
        var layers = [this.mapLayerService.dataLayerName, this.mapLayerService.bgSurroundingsLayerName];
        var lineLayer = this.map.addedLayers[this.mapLayerService.addressLineLayerName];
        if (!lineLayer.getSource().getFeatureById(id)) {
            layers.find(function (name) {
                var layer = _this.map.addedLayers[name];
                var feat = layer.getSource().getFeatureById(id);
                if (feat) {
                    _this.selectedRoadsById[id].feat = feat;
                    lineLayer.getSource().addFeature(feat);
                    return true;
                }
            });
        }
    };
    A3iWizardComponent.prototype.handleParseResult = function (data) {
        var _this = this;
        var numOfChangedCards = 0;
        if (data) {
            data.forEach(function (result) {
                var inputAddr = result[_this.attrIndexService.parseInputAddrCol];
                var roadIds = Object.keys(_this.selectedRoadsById).filter(function (id) { return _this.selectedRoadsById[id].parseAddress === inputAddr; });
                roadIds.forEach(function (id) {
                    var changedAttrs = [];
                    var attrs = _this.selectedRoadsById[id].attrs;
                    _this.stStandardCols.forEach(function (col) {
                        var colProp = _this.centerlineCate.colPrefix + '_' + col.colName.toLowerCase();
                        var resultProp = col.colName.toLowerCase();
                        if (_this.editService.hasValueChanged(attrs[colProp], result[resultProp])) {
                            changedAttrs.push(colProp);
                            attrs[colProp] = result[resultProp];
                        }
                    });
                    _this.lstStandardCols.forEach(function (col) {
                        var colProp = _this.centerlineCate.colPrefix + '_' + col.colName.toLowerCase();
                        var resultProp = col.colName.toLowerCase();
                        if (_this.editService.hasValueChanged(attrs[colProp], result[resultProp])) {
                            changedAttrs.push(colProp);
                            attrs[colProp] = result[resultProp];
                        }
                        // attrs[colProp] = result[resultProp];
                    });
                    if (!_this.mainDataService.getDataAttrs(id)) {
                    }
                    else if (changedAttrs.length) {
                        changedAttrs.forEach(function (key) { return _this.mainDataService.setDataAttrs(id, key, attrs[key]); });
                        _this.mainDataService.addRecToCard(id);
                        numOfChangedCards++;
                    }
                });
            });
            if (numOfChangedCards === 0) {
                this.toastr.info('No change is needed');
            }
            else {
                this.activityService.changeTabSubject.next({
                    tabKey: 'data'
                });
                this.toastr.info('Added to cards');
            }
        }
    };
    A3iWizardComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var centerlineLayerCate, stdSchema, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.centerlineLayerId = this.layerService.layerListBS.getValue().layers.find(function (l) { return l.category.code === _this.attrIndexService.cateCodeCenterline; }).id;
                        centerlineLayerCate = this.appinfoService.layerTypeList.find(function (i) { return i.code === _this.attrIndexService.cateCodeCenterline; });
                        if (!!centerlineLayerCate.standardCols) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fieldMappingService.getStandardSchema(centerlineLayerCate.id)];
                    case 2:
                        stdSchema = _a.sent();
                        centerlineLayerCate.standardCols = stdSchema;
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        this.toastr.info('Centerline layer schema not found.');
                        console.log(err_3);
                        return [3 /*break*/, 4];
                    case 4:
                        this.centerlineCate = centerlineLayerCate;
                        this.lstStandardCols = this.a3iService.getLstStandardCols(centerlineLayerCate.standardCols);
                        this.stStandardCols = this.a3iService.getStStandardCols(centerlineLayerCate.standardCols);
                        this.changeCurrentStep(this.steps[0]);
                        return [2 /*return*/];
                }
            });
        });
    };
    A3iWizardComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.mapSub = this.mapService.mapBS.subscribe(function (data) {
            _this.map = data;
            if (!_this.map.addedLayers[_this.mapLayerService.addressLineLayerName]) {
                _this.mapLayerService.addAddressLineLayer(_this.map);
            }
        });
        this.mapMoveendSub = this.mapService.mapMoveendSubject.subscribe(function (data) {
            if (_this.currentStep && _this.currentStep.prop === 'selectRCLs') {
                Object.keys(_this.selectedRoadsById).forEach(function (id) {
                    if (!_this.selectedRoadsById[id].feat) {
                        _this.updateStoredFeat(id);
                    }
                });
            }
        });
    };
    A3iWizardComponent.prototype.ngOnDestroy = function () {
        this.mapSub.unsubscribe();
        this.mapMoveendSub.unsubscribe();
    };
    return A3iWizardComponent;
}());
export { A3iWizardComponent };
